import React from 'react';
import { AnalysisResult } from '../services/projectService';
import ResultAccordion from './ResultAccordion';
import './HistoryModal.css';
import { FaTimes } from 'react-icons/fa';

interface HistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  history: AnalysisResult[];
}

const HistoryModal: React.FC<HistoryModalProps> = ({ isOpen, onClose, history }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>Version History</h2>
          <button className="modal-close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </header>
        <div className="timeline-container">
          {history.map((version, index) => {
            const creationDate = new Date(version.created_at).toLocaleString();
            return (
              <div key={version.id} className="timeline-item">
                <div className="timeline-marker"></div>
                <div className="timeline-header">
                  <div className="version-details">
                    <span className="version-number">Version {history.length - index}</span>
                    <span className="version-date">{creationDate}</span>
                  </div>
                  <span className={`status-badge status-${version.workflow_stage.toLowerCase().replace(/_/g, '-')}`}>
                    {version.workflow_stage.replace(/_/g, ' ')}
                  </span>
                </div>
                <div className="timeline-result-card">
                  <div className="card-section header-legal-reference">
                    <strong>{version.matrix_item.ley}</strong><br/>
                    <small>{version.matrix_item.articulo}</small>
                  </div>
                  <div className="card-section header-category">
                    {version.matrix_item.categoria}
                    <br />
                    <small>{version.matrix_item.grupo_delitos}</small>
                  </div>
                  <div className="card-section result-details">
                    <ResultAccordion result={version} />
                  </div>
                  {version.additional_context && (
                    <div className="card-section additional-context">
                      <div className="additional-context-display">
                        <h4>Additional Context Provided:</h4>
                        <p>{version.additional_context}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HistoryModal; 